export class getAcceptLanguage {

    public static getLocalStorageLanguage() {
        var lang = JSON.parse(localStorage.getItem('language-code'));
        if (lang == null) lang = 'bs';
        if (lang == undefined) lang = 'bs';
        return lang;
    }

}